module.exports = __webpack_public_path__ + "img/t3-12.0682a632.svg";